<template>
    <div v-if="revision">
        <div v-if="!isRevHistoryPage" class="text-h6 q-mb-md">
            Revision Notes
        </div>
        <div class="q-mb-md">
            <div :class="!isRevHistoryPage ? 'text-caption' : 'q-pb-xs q-pl-xs'" :style="!isRevHistoryPage ? '' : 'font-size: 1rem; font-weight: 500;'">Version {{ revision.version }} ({{ revision.releaseDate | date }})</div>
            <q-list separator bordered>
                <q-expansion-item v-if="revision.newFeatures && !isRevHistoryPage"
                                  icon="mdi-new-box"
                                  label="New & Enhanced Features">
                    <q-card>
                        <q-card-section v-html="revision.newFeatures" />
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-else-if="revision.newFeatures && isRevHistoryPage"
                                  v-model="expandedDisabled"
                                  :disable="expandedDisabled"
                                  :header-class="{ 'disabled-header': expandedDisabled }"
                                  icon="mdi-new-box"
                                  label="New & Enhanced Features">
                    <q-card>
                        <q-card-section v-html="revision.newFeatures" />
                    </q-card>
                </q-expansion-item>

                <q-expansion-item v-if="revision.fixes && !isRevHistoryPage"
                                  icon="mdi-auto-fix"
                                  label="Fixes">
                    <q-card>
                        <q-card-section v-html="revision.fixes" />
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-else-if="revision.fixes && isRevHistoryPage"
                                  v-model="expandedDisabled"
                                  :disable="expandedDisabled"
                                  :header-class="{ 'disabled-header': expandedDisabled }"
                                  icon="mdi-auto-fix"
                                  label="Fixes">
                    <q-card>
                        <q-card-section v-html="revision.fixes" />
                    </q-card>
                </q-expansion-item>

                <q-expansion-item v-if="revision.oemChanges && !isRevHistoryPage"
                                  icon="mdi-information-outline"
                                  label="OEM Changes">
                    <q-card>
                        <q-card-section v-html="revision.oemChanges" />
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-else-if="revision.oemChanges && isRevHistoryPage"
                                  v-model="expandedDisabled"
                                  :disable="expandedDisabled"
                                  :header-class="{ 'disabled-header': expandedDisabled }"
                                  icon="mdi-information-outline"
                                  label="OEM Changes">
                    <q-card>
                        <q-card-section v-html="revision.oemChanges" />
                    </q-card>
                </q-expansion-item>

                <q-expansion-item v-if="!revision.newFeatures && !revision.fixes && !revision.oemChanges && !isRevHistoryPage"
                                  icon="mdi-information-outline"
                                  label="Other">
                    <q-card>
                        <q-card-section v-html="revision.revision" />
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-else-if="!revision.newFeatures && !revision.fixes && !revision.oemChanges && isRevHistoryPage"
                                  v-model="expandedDisabled"
                                  :disable="expandedDisabled"
                                  :header-class="{ 'disabled-header': expandedDisabled }"
                                  icon="mdi-information-outline"
                                  label="Other">
                    <q-card>
                        <q-card-section v-html="revision.revision" />
                    </q-card>
                </q-expansion-item>
            </q-list>
        </div>
    </div>
</template>
<script>
    import { ref } from 'vue'

    export default {
        name: 'revision-notes',
        props: {
            revision: Object,
            isRevHistoryPage: {
                default: false,
                type: Boolean
            },
        },
        data() {
            return {
                expandedDisabled: ref(true),
            }
        },
        created() {
            var rev = this.revision;
        },
        watch: {
            revision(newVal, oldVal) {
                var oldRev = oldVal
                var rev = newVal
            }
        }
    }
</script>
<style scoped>

    >>> .disabled-header {
        opacity: 1 !important;
        cursor: default !important;
    }

        >>> .disabled-header * {
            cursor: default !important;
        }
</style>
